<!-- eslint-disable i18next/no-literal-string -->
<template>
  <div class="mc-videohistory-list__container">
    <div class="mc-videohistory-list__wrapper">
      <div class="mc-videohistory-list__top-container">
        <div class="mc-videohistory-list__period-container">
          <p>{{ $t('videoHistory.sidebar.title') }}</p>
          <button id="periodeInfo" class="mc-videohistory-list__tooltip--button">
            <i class="mc-fa icon-outline_info icon-primary icon-sm"></i>
          </button>
        </div>

        <div class="mc-videohistory-list__datepicker-container"></div>
      </div>

      <div class="mc-videohistory-list__time-period--container">
        <date-picker
          ref="periodePicker"
          v-model="$store.state.vehicle.period"
          type="datetime"
          :placeholder="$t('global.action.selectDate')"
          format="DD MMM YYYY HH:mm"
          value-type="YYYY-MM-DD HH:mm"
          range-separator=" - "
          range
          :class="datePickerClasses"
          :confirm="false"
          :clearable="false"
          :disabled-date="disableFutureDates"
          :disabled="$store.state.vehicle.isLoadingVehicleVideos"
          :lang="datePickerLang"
          @pick="pickDate"
        >
          <template #input>
            <input
              v-if="$store.state.vehicle.period.length"
              name="date"
              type="text"
              autocomplete="off"
              placeholder="Pilih Tanggal"
              class="mx-input"
              :value="`${momentDMYH($store.state.vehicle.period[0])} - ${momentTime(
                $store.state.vehicle.period[1]
              )}`"
              :disabled="$store.state.vehicle.isLoadingVehicleVideos"
            />
          </template>
          <template #footer>
            <span class="mr-3">
              {{ momentDMYH($store.state.vehicle.period[0]) }} -
              {{ momentTime($store.state.vehicle.period[1]) }}
            </span>
            <b-button class="mx-2" variant="outline-primary" @click="cancelCalendar">
              {{ $t('global.action.cancel') }}
            </b-button>
            <b-button
              variant="primary"
              :disabled="$store.state.vehicle.isLoadingVehicleVideos"
              @click="applied"
            >
              {{ $t('global.action.apply') }}
            </b-button>
          </template>
        </date-picker>
      </div>
      <div class="mc-videohistory-reload--container">
        <div
          v-if="$store.state.vehicle.isLoadingVehicleVideos"
          class="mc-videohistory-reload--loading"
        >
          <b-spinner label="Loading..." />
        </div>

        <div v-else class="mc-videohistory-reload--wrapper">
          <p v-if="vehicleVideoHistory.lastUpdate">
            {{ $t('videoHistory.video.lastUpdate') }}:
            {{ momentDMY_HI(vehicleVideoHistory.lastUpdate) }}
          </p>

          <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
          <p v-else>{{ $t('videoHistory.video.lastUpdate') }}: -</p>

          <span @click="reload">
            <i class="mc-fa icon-fill_refresh"></i>
            {{ $t('videoHistory.video.reload') }}
          </span>
        </div>
      </div>
      <div class="mc-videohistory-list__divider" />
      <HistoryList />
    </div>

    <b-tooltip target="periodeInfo" triggers="hover">
      {{ $t('videoHistory.infoPeriode') }}
    </b-tooltip>
  </div>
</template>

<script>
import HistoryList from './Histories/HistoryList'
import responsive from '@/mixin/responsive'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'
import datePickerLang from '@/helpers/date-picker-lang'
import moment from 'moment'

export default {
  name: 'VideoHistoryList',
  components: {
    DatePicker,
    HistoryList,
  },
  mixins: [Helper, responsive, MixPanel],
  data() {
    return {
      inputDate: [],
    }
  },
  computed: {
    ...mapGetters('vehicle', [
      'vehicleId',
      'vehicleDetail',
      'vehiclePeriod',
      'vehicleVideoHistory',
      'vehicleCameraPosition',
    ]),
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    datePickerClasses() {
      return {
        'mc-history-modal__list-date': true,
        'mc-videohistory-button-disabled': this.$store.state.vehicle.isLoadingVehicleVideos,
      }
    },
    datePickerLang() {
      return datePickerLang()
    },
    isVideoDemo() {
      const dataDemoVideoHistory = this.getFeatureFlagValue('vsms2_trackvision2_playback_demo_id')
      return Object.keys(dataDemoVideoHistory).includes(this.$route.params.vehicleId.toString())
    },
  },

  async created() {
    this.$store.commit('vehicle/clearPeriod')
  },
  async mounted() {
    if (this.vehicleId) {
      await this.loadVehicle(this.vehicleId)
    }
    if (this.isVideoDemo) {
      this.initLoadVehicleVideosDemo()
    } else {
      this.initLoadVehicleVideos()
    }
  },
  methods: {
    closePopup() {
      if (this.$refs.periodePicker) {
        this.$refs.periodePicker.closePopup()
      }
    },

    duplicatePeriodeForTemp() {
      this.$store.commit('vehicle/setDuplicatePeriod')
    },

    disableFutureDates(date) {
      const currentDate = new Date()

      return date > currentDate
    },

    cancelCalendar() {
      this.$store.commit('vehicle/setDuplicatePeriodTemp')
      this.closePopup()
    },

    updatePeriodState(periode) {
      this.$store.commit('vehicle/setVehicleHistoryPeriod', periode)
    },

    async loadVehicle(vehicleId) {
      await this.$store.dispatch('vehicle/requestVehicleVideoTrackerByVehicleId', vehicleId)
    },

    async requestFileList() {
      if (!this.vehicleDetail?.imei) return
      await this.$store.dispatch('vehicle/requestUpdateFileList', {
        input: {
          imei: this.vehicleDetail.imei,
        },
      })
    },

    async requestVehicleVideos(vehicleId, isFromCache) {
      this.$store.commit('vehicle/clearVideoStates')
      const filter = {
        vehicleId: vehicleId,
        startTime: this.formatDateToUtc(this.vehiclePeriod[0]),
        endTime: this.formatDateToUtc(this.vehiclePeriod[1]),
        channel: this.$store.state.vehicle.camera,
        fileListOnly: true,
        isFromCache,
      }
      const response = await this.$store.dispatch('vehicle/requestVehicleVideosTv2', filter)
      return response
    },

    async initLoadVehicleVideosDemo() {
      this.$store.commit('vehicle/setLoadingVehicleVideos', true)
      await this.delay(500)
      if (this.vehiclePeriod.length === 0) {
        this.vehiclePeriod[0] = moment(new Date()).format('YYYY-MM-DD 00:00:00')
        this.vehiclePeriod[1] = moment(new Date()).format('YYYY-MM-DD HH:mm:59')

        this.$store.dispatch('vehicle/setVehicleVideosDemo', {
          vehicleId: this.$route.params.vehicleId.toString(),
          channel: this.$store.state.vehicle.camera.slice(2),
        })
        this.$store.commit('vehicle/setLoadingVehicleVideos', false)
      }
    },

    async initLoadVehicleVideos() {
      this.$store.commit('vehicle/setLoadingVehicleVideos', true)
      if (this.vehiclePeriod.length === 0) {
        this.vehiclePeriod[0] = moment(new Date()).format('YYYY-MM-DD 00:00:00')
        this.vehiclePeriod[1] = moment(new Date()).format('YYYY-MM-DD HH:mm:59')
        this.updatePeriodState(this.vehiclePeriod)
        await this.$nextTick()
        await this.requestFileList()
        if (this.$store.state.vehicle.vehicleDetail.deviceName === 'bsj') {
          await this.delay(3000)
        }
        if (this.$store.state.vehicle.vehicleDetail.deviceName === 'jc') {
          await this.delay(5000)
        }
        let response
        response = await this.requestVehicleVideos(this.vehicleId, true)
        this.duplicatePeriodeForTemp()
        if (!response.files.length) {
          if (this.$store.state.vehicle.vehicleDetail.deviceName === 'bsj') {
            await this.delay(4000)
          }
          if (this.$store.state.vehicle.vehicleDetail.deviceName === 'jc') {
            await this.delay(4000)
          }
          response = await this.requestVehicleVideos(this.vehicleId, false)
        }
        this.$store.dispatch('vehicle/splitVehicleVideos', {
          videoFiles: response.files,
          lastUpdate: response.lastUpdate,
          deviceTimezone: response.deviceTimezone,
          filter: {
            startTime: this.formatDateToUtc(this.vehiclePeriod[0]),
            endTime: this.formatDateToUtc(this.vehiclePeriod[1]),
          },
        })
        this.$store.commit('vehicle/setLoadingVehicleVideos', false)
      }
    },

    async pickDate(date) {
      const pickerRefs = this.$refs.periodePicker.$refs.picker
      const overrideDefaultTime = moment(date)
        .set({
          hour: '23',
          minute: '59',
          second: '59',
        })
        .toDate()
      if (!pickerRefs.defaultTimeVisible) {
        this.updatePeriodState([date, overrideDefaultTime])
        await this.$nextTick()
        pickerRefs.value[0] = date
        pickerRefs.value[1] = overrideDefaultTime
        pickerRefs.openTimePanel()
      }
    },

    async applied() {
      this.$store.commit('vehicle/setVideoStatusDetail', 'noVideo')
      this.$store.commit('vehicle/setLoadingVehicleVideos', true)
      this.duplicatePeriodeForTemp()
      this.closePopup()
      this.vehiclePeriod[0] = moment(this.vehiclePeriod[0]).format('YYYY-MM-DD HH:mm:00')
      this.vehiclePeriod[1] = moment(this.vehiclePeriod[1]).format('YYYY-MM-DD HH:mm:59')
      this.updatePeriodState(this.vehiclePeriod)
      await this.$nextTick()
      if (this.isVideoDemo) {
        await this.delay(500)
        this.$store.dispatch('vehicle/setVehicleVideosDemo', {
          vehicleId: this.$route.params.vehicleId.toString(),
          channel: this.$store.state.vehicle.camera.slice(2),
        })
      } else {
        await this.requestFileList()
        if (this.$store.state.vehicle.vehicleDetail.deviceName === 'bsj') {
          await this.delay(3000)
        }
        if (this.$store.state.vehicle.vehicleDetail.deviceName === 'jc') {
          await this.delay(5000)
        }
        let response
        response = await this.requestVehicleVideos(this.vehicleId, true)
        if (!response.files.length) {
          if (this.$store.state.vehicle.vehicleDetail.deviceName === 'bsj') {
            await this.delay(4000)
          }
          if (this.$store.state.vehicle.vehicleDetail.deviceName === 'jc') {
            await this.delay(4000)
          }
          response = await this.requestVehicleVideos(this.vehicleId, false)
        }
        await this.$store.dispatch('vehicle/splitVehicleVideos', {
          videoFiles: response.files,
          lastUpdate: response.lastUpdate,
          deviceTimezone: response.deviceTimezone,
          filter: {
            startTime: this.formatDateToUtc(this.vehiclePeriod[0]),
            endTime: this.formatDateToUtc(this.vehiclePeriod[1]),
          },
        })
      }

      await this.$store.commit('vehicle/setLoadingVehicleVideos', false)
      this.closePopup()
    },

    async reload() {
      this.track('Click Video History Reload', {
        license_plate: this.vehicleDetail.licensePlate,
      })

      if (this.isVideoDemo) {
        await this.$store.commit('vehicle/setLoadingVehicleVideos', true)
        await this.delay(500)
        await this.$store.commit('vehicle/setLoadingVehicleVideos', false)
        return
      }

      await this.$store.commit('vehicle/setLoadingVehicleVideos', true)
      this.$store.commit('vehicle/setLoadingVehicleVideos', true)
      this.vehiclePeriod[0] = moment(Date.now()).format('YYYY-MM-DD 00:00:00')
      this.vehiclePeriod[1] = moment(Date.now()).format('YYYY-MM-DD HH:mm:59')
      await this.$nextTick()
      await this.requestFileList()
      if (this.$store.state.vehicle.vehicleDetail.deviceName === 'bsj') {
        await this.delay(3000)
      }
      if (this.$store.state.vehicle.vehicleDetail.deviceName === 'jc') {
        await this.delay(5000)
      }
      let response
      response = await this.requestVehicleVideos(this.vehicleId, true)
      if (!response.files.length) {
        if (this.$store.state.vehicle.vehicleDetail.deviceName === 'bsj') {
          await this.delay(4000)
        }
        if (this.$store.state.vehicle.vehicleDetail.deviceName === 'jc') {
          await this.delay(4000)
        }
        response = await this.requestVehicleVideos(this.vehicleId, false)
      }
      await this.$store.dispatch('vehicle/splitVehicleVideos', {
        videoFiles: response.files,
        lastUpdate: response.lastUpdate,
        deviceTimezone: response.deviceTimezone,
        filter: {
          startTime: this.formatDateToUtc(this.vehiclePeriod[0]),
          endTime: this.formatDateToUtc(this.vehiclePeriod[1]),
        },
      })

      await this.$store.commit('vehicle/setLoadingVehicleVideos', false)
    },
  },
}
</script>
